import Base from "+/Engine/Base";

/**
 * A lightweight reference to an entity by type and primary key.
 *
 * Use EntityReference everywhere a type/pk pair is stored together (e.g. oneEntity field values,
 * action params, cross-entity pointers). When the reference is later consumed, the entityType
 * allows validation that the referenced entity matches the expected type before using the pk.
 */
export default class EntityReference extends Base {
  entityType;
  pk;

  constructor(entityType, pk) {
    super();
    this.pk = pk;
    this.entityType = entityType;
  }
}
